import * as t from "io-ts";

export interface ISavePresetParams {
  id?: number;
  name?: string;
  page?: string;
  parameters?: {
    filter?: string | null;
    groupBy?: Array<string>;
    orderDir?: string;
    orderField?: string;
    rowsOnPage?: number;
    timazone?: number;
  };
}

export const tParameter = t.strict({
  agregatedFields: t.array(t.string), // ["bids", "wins", "impressions", "clicks", "ctr", "ecpm", "ecpc", "dspSpend"]
  filter: t.string, // {}
  groupBy: t.array(t.string), // ["YMD", "campaignId"]
  orderDir: t.string, //"desc"
  orderField: t.string, // "bids"
  rowsOnPage: t.number, // 15
  timezone: t.number, // [-12 ... 0 ... 12]
});

export const tPreset = t.strict({
  id: t.number,
  name: t.string,
  userId: t.number,
  page: t.string,
  parameters: tParameter,
});

export const tPresets = t.strict({
  data: t.array(tPreset),
});

export type Preset = t.TypeOf<typeof tPreset>;
export type Presets = t.TypeOf<typeof tPresets>;
